module.exports = __webpack_public_path__ + "swiss_flag_footer.svg?a87b3b6029bad1a45234f0fac0df5576";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swiss_flag_footer.svg
// module id = 110
// module chunks = 0